import { Helmet } from 'react-helmet-async';

const SITE = 'Podcasters.Directory';
const BASE_URL = 'https://podcasters.directory';
const DEFAULT_DESC = 'The #1 podcast host and guest marketplace. Discover podcasters, get matched with perfect collaborators, and grow your audience.';
const DEFAULT_IMG = '/og-image.png';

// Scrapers (Slack, Facebook, LinkedIn, X/Twitter, iMessage, WhatsApp) require ABSOLUTE URLs for og:image.
const absolutize = (url) => {
  if (!url) return `${BASE_URL}${DEFAULT_IMG}`;
  if (/^https?:\/\//i.test(url)) return url;
  return `${BASE_URL}${url.startsWith('/') ? url : `/${url}`}`;
};

export default function SEO({ title, description, path = '', image, type = 'website', jsonLd, breadcrumbs }) {
  const fullTitle = title ? `${title} - ${SITE}` : `${SITE} - Find Your Perfect Podcast Match`;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE_URL}${path}`;
  const img = absolutize(image || DEFAULT_IMG);

  const breadcrumbLd = breadcrumbs ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs.map((b, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": b.name,
      "item": `${BASE_URL}${b.path}`
    }))
  } : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:image:secure_url" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={fullTitle} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={fullTitle} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
      {breadcrumbLd && <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>}
    </Helmet>
  );
}
